/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, date, DateFormat, entity, subentity } from '@gh/core-data';
import {
  CashFlowForecastDetailsDto,
  CashFlowForecastJobDto,
} from './cash-flow-forecast-details.dto';

export const CashFlowForecastDetailsMapper = entity<CashFlowForecastDetailsDto>({
  jobs: arrayOf(subentity<CashFlowForecastJobDto>({
    startDate: date(DateFormat.DateTime),
    endDate: date(DateFormat.DateTime),
  })),
});
